<template>
  <li class="search-result-item">
    <a href="#" class="result" @click.prevent="() => emits('select', item)">
      {{ props.item.shwrd }}
    </a>
    <span class="date">{{ dayjs(props.item.regDts).format("MM.DD") }}</span>
    <button
      type="button"
      class="btn-delete"
      @click="() => emits('delete', item)"
    >
      <span class="c-icon icon-small-x"></span>
      <span class="sr-only">검색어 삭제</span>
    </button>
  </li>
</template>
<script setup>
import { onMounted, defineProps, defineEmits } from "vue";
import dayjs from "dayjs";

const emits = defineEmits(["delete", "select"]);

const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
});

onMounted(() => {});
</script>
